import { getOffsetTop } from './get-offset-top';
import { observe, unobserve } from 'appear-event';

const defaultDuration = 750;

interface AnimateProps {
  accX?: number;
  accY?: number;
  delay?: number;
  duration?: number;
  minWindowWidth?: number;
}

export default class Animate implements AnimateProps {
  accX = 0;
  accY = -80;
  delay = 100;
  duration: number = defaultDuration;
  minWindowWidth = 767;
  private readonly wrapper: HTMLElement;
  private readonly intersectionObserverOptions: IntersectionObserverInit = {};
  private ticking = false;

  constructor(element: HTMLElement, props?: AnimateProps) {
    this.wrapper = element;
    if (props) {
      Object.assign(this, props);
    }
    this.intersectionObserverOptions.rootMargin = `${this.accY}px ${this.accX}px ${this.accY}px ${this.accX}px`;
    observe(this.wrapper, this.intersectionObserverOptions);

    this.animate();
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private animate(): void {
    const _this = this;

    if (!this.ticking) {
      const elTopDistance = getOffsetTop(this.wrapper);
      const windowTopDistance = window.scrollY;

      window.requestAnimationFrame(function () {
        _this.wrapper.classList.add('appear-animation', 'animated');
        if (window.innerWidth > _this.minWindowWidth && elTopDistance >= windowTopDistance) {
          const onAppear = function (): void {
            _this.wrapper.addEventListener('animation:show', function (_e) {
              const delay = _this.wrapper.getAttribute('data-appear-animation-delay')
                ? parseInt(_this.wrapper.getAttribute('data-appear-animation-delay') as string)
                : _this.delay;
              const duration = _this.wrapper.getAttribute('data-appear-animation-duration')
                ? parseInt(_this.wrapper.getAttribute('data-appear-animation-duration') as string)
                : _this.duration;
              const appearAnimation = _this.wrapper.getAttribute('data-appear-animation');

              if (appearAnimation) {
                if (duration !== defaultDuration) {
                  _this.wrapper.style.animationDuration = `${duration}ms`;
                }

                _this.wrapper.style.animationDelay = `${delay}ms`;

                _this.wrapper.classList.add(appearAnimation, 'appear-animation-visible');
              }

              _this.wrapper.removeEventListener('appear', onAppear, false);
              unobserve(_this.wrapper, _this.intersectionObserverOptions);
            }, false);

            _this.wrapper.dispatchEvent(new Event('animation:show'));
          };

          _this.wrapper.addEventListener('appear', onAppear);
        } else {
          _this.wrapper.classList.add('appear-animation-visible');
        }

        _this.ticking = false;
      });

      this.ticking = true;
    }
  }
}
